import { ChangeDetectorRef, Component, EventEmitter, inject, Input, NgZone, OnChanges, OnDestroy, OnInit, Output, signal, SimpleChanges } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { firstValueFrom, Subscription } from 'rxjs';
import { PERMISSION_CONSTANT } from '../../../../../constants/permission';
// import { ScheduleService } from 'src/app/state/modules/schedule/services/schedule.service';
import { BREAK_TYPE_ENUM } from '../../../../../constants/lookup/common/break-type.enum';
import { TimeSheetBreakType } from '../../../../../constants/lookup/timesheet/break-type.enum';
import { TimesheetEnum } from '../../../../../constants/lookup/timesheet/timesheet-status.enum';
import { TimesheetType } from '../../../../../constants/lookup/timesheet/timesheet-type.enum';
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { SCHEDULE_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/schedule';
import { TIMESHEET_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/timesheet';
import { AMPLITUDE_EVENT, AmplitudeService } from '../../../../../core/services/amplitude.service';
import { SignalRService } from '../../../../../core/services/signal-r.service';
import { CommonUtil } from '../../../../../core/utils/common-util';
import { DateUtil } from '../../../../../core/utils/date-util';
import { LocalStorageUtil } from '../../../../../core/utils/local-storage-util';
import { ModalButtonType } from '../../../../../models/common/modal/modal-config';
import { ScheduleShiftComponent } from '../../../../../modules/main/schedule/components/schedule-shift/schedule-shift.component';
import { EndBreakComponent } from '../../../../../modules/main/shift-info/components/end-break/end-break.component';
import { EndLoopComponent } from '../../../../../modules/main/shift-info/components/end-loop/end-loop.component';
import { MakeLoopScanComponent } from '../../../../../modules/main/shift-info/components/make-loop-scan/make-loop-scan.component';
import { ScanAreaComponent } from '../../../../../modules/main/shift-info/components/scan-area/scan-area.component';
import { ShiftFormListComponent } from '../../../../../modules/main/shift-info/components/shift-form-list/shift-form-list.component';
import { ShiftLoopListComponent } from '../../../../../modules/main/shift-info/components/shift-loop-list/shift-loop-list.component';
import { ShiftRewardListComponent } from '../../../../../modules/main/shift-info/components/shift-reward-list/shift-reward-list.component';
import { ShiftScheduleActualDetailsComponent } from '../../../../../modules/main/shift-info/components/shift-schedule-actual-details/shift-schedule-actual-details.component';
import { ShouldEndShiftComponent } from '../../../../../modules/main/shift-info/components/should-end-shift/should-end-shift.component';
import { StartBreakComponent } from '../../../../../modules/main/shift-info/components/start-break/start-break.component';
import { StartLoopComponent } from '../../../../../modules/main/shift-info/components/start-loop/start-loop.component';
import { StartShiftComponent } from '../../../../../modules/main/shift-info/components/start-shift/start-shift.component';
import { ShfitFunction } from '../../../../../modules/main/shift-info/components/start-shift/start-shift.constant';
import { StartUnscheduledShiftComponent } from '../../../../../modules/main/shift-info/components/start-unscheduled-shift/start-unscheduled-shift.component';
import { TaskGroupListComponent } from '../../../../../modules/main/shift-info/components/task-group-list/task-group-list.component';
import { AdvanceTaskActivityComponent } from '../../../../../modules/main/shift-info/components/advance-task-activity/advance-task-activity.component';
import { CountType, END_SHIFT_MODAL_CONSTANTS, START_FORM_GEOFENCE_RESPONSE_CODE, START_SHIFT_GEOFENCE_MODAL_CONSTANTS, START_SHIFT_GEOFENCE_RESPONSE_CODE } from '../../../../../modules/main/shift-info/pages/shift-info-main/shift-info-main.constant';
import { ShiftInfoMainService } from '../../../../../modules/main/shift-info/services/shift-info-main.service';
import { AuthStoreService } from '../../../../../state/modules/auth/auth-store.service';
import { EmployeeStoreService } from '../../../../../state/modules/employee/employee-store.service';
import { MasterBusinessStoreService } from '../../../../../state/modules/master-business/master-business-store.service';
import { ScheduleStoreService } from '../../../../../state/modules/schedule/schedule-store.service';
import { ScheduleService } from '../../../../../state/modules/schedule/services/schedule.service';
import { TimesheetStoreService } from '../../../../../state/modules/timesheet/timesheet-store.service';
import { HandoverNotesComponent } from '../../../../main/handover-notes/pages/handover-notes/handover-notes.component';
import { ModalBaseClass } from '../../modals/base_class/modal-base-class';
import { NotificationComponent } from '../../modals/notification/notification.component';
import { ShiftControlActualInfoComponent } from '../../shift-control-actual-info/shift-control-actual-info.component';
import { ALERT_MESSAGES } from '../../../../../constants/messages/message.constant';
import { BusinessService } from '../../../../../state/modules/business/services/business.service';
import { CheckPendingFormComponent } from '../../../../main/shift-info/components/check-pending-form/check-pending-form.component';
import { PERMISSIONV2 } from '../../../../../constants/permissionv2/role-permission';
import { NgxPermissionsService } from 'ngx-permissions';
import { ToasterService } from '../../../../../core/services/toaster.service';
import { LocationResourcesViewComponent } from '../../../../../modules/main/client/pages/client-info/pages/location/components/location-resources-view/location-resources-view.component';
import { ResourceTab } from '../../../../../state/modules/resource/resource-api.model';
import { ShiftPatrolListComponent } from '../../../../../modules/main/shift-info/components/shift-patrol-list/shift-patrol-list.component';
import { MasterService } from '../../../../../state/master/services/master.service';

@Component({
  standalone: false,
  selector: 'kt-shift-control',
  templateUrl: './shift-control.component.html',
  styleUrls: ['./shift-control.component.scss'],
})
export class ShiftControlComponent extends ModalBaseClass implements OnInit, OnChanges, OnDestroy {

  shiftInfo: any = null;
  _selectedUserId;
  loggedInUserId;
  _selectedUserData;
  isSameUser = true;
  permissionConstant = PERMISSION_CONSTANT;
  permissionV2 = PERMISSIONV2

  subscriptions: Subscription[] = [];
  shiftTimeSheetDetails = null;
  currentStatus = TimesheetEnum.NONE;
  timeSheetEnumRef = TimesheetEnum;
  businessName = '';
  profile: '';
  reasons = null;
  timesheet = null;
  timeElapsed = signal('');
  showLocationError = false;
  unscheduledShiftData = null;
  interval = null;
  timesheetBreak = null;
  unseenHandoverNotes = false;
  /** is_advance_task on the shift info: the shift has advance tasks worth opening. */
  hasAdvanceTask = signal(false);

  location = {
    latitude: 0,
    logitude: 0,
  };
  loading = signal(false);
  userProfileRole

  counts = {
    shift_form_count: 0,
    // shift_loop_count: 0,
    shift_patrol_count: 0,
    shift_reward_count: 0,
    shift_task_group_count: 0,
  };
  activeScreen = {
    mainScreen: true,
    shiftInfo: false,
  };
  user$: any = null;
  isLoggedInUserProfile: boolean = false;

  @Input() _loading(isLoading) {
    this.loading.set(isLoading);
  }

  @Input() where;
  @Input() set selectedUserData(data) {
    this.loading.set(true);
    if (data && data.user && data.user.user_id) {
      this.loading.set(false);
      this._selectedUserId = data.user.user_id;
    }
  }
  @Output() showDetailsPanel: EventEmitter<boolean> = new EventEmitter();

  private readonly ngZone = inject(NgZone);

  constructor(
    private authStoreService: AuthStoreService,
    public modalService: NgbModal,
    private scheduleStoreService: ScheduleStoreService,
    private signalRService: SignalRService,
    private timesheetService: TimesheetStoreService,
    public shiftInfoMainService: ShiftInfoMainService,
    public scheduleService: ScheduleService,
    public businessService: BusinessService,
    public ngbModal: NgbModal,
    private toastr: ToasterService,
    public masterBusinessStore: MasterBusinessStoreService,
    public ngxPermssionService: NgxPermissionsService,
    private cdr: ChangeDetectorRef
  ) {
    super(ngbModal);
  }

  ngOnInit() {
    this.setLoggedInUserProfile()
    this.businessName = LocalStorageUtil.getBusinessName();
    // this.dispatchGetShiftInfo();
    this.setLocation();
    this.loggedInUserId = LocalStorageUtil.getUserId();
    this.userProfileRole = LocalStorageUtil.getUserBusinessRole();
    this.user$ = this.authStoreService.selectUser();

    this.businessService.getUnseenHandoverNotes(this._selectedUserId).subscribe(res => {
      this.unseenHandoverNotes = res && res.data && res.data.hand_over_note_comment ? res.data.hand_over_note_comment : false;
    });

    this.subscriptions.push(this.signalRService.realTimeStatus$.subscribe(value => {
      // Need to refresh shift data on each changes
      if (value) {
        this.dispatchGetShiftInfo();
      }

      // Keeping old logic in comment for refrence
      // if (value && ((value.timesheetVM && value.timesheetVM.timesheet_id && this.timesheet && value.timesheetVM.timesheet_id === this.timesheet.timesheet_id)
      //   || (value.transactionLogVM && value.transactionLogVM.timesheet_log_fk_timesheet_id && this.timesheet && value.transactionLogVM.timesheet_log_fk_timesheet_id === this.timesheet.timesheet_id)
      //   || (value.transactionVM && value.transactionVM.timesheet_transaction_fk_timesheet_id && this.timesheet && value.transactionVM.timesheet_transaction_fk_timesheet_id === this.timesheet.timesheet_id)
      // )
      // ) {
      //   this.dispatchGetShiftInfo();
      // }

    }));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.where && changes.where.currentValue === 'shiftInfo') {
      this._selectedUserId = LocalStorageUtil.getUserId();
      this.dispatchGetShiftInfo();
    }

    if (changes && changes.selectedUserData && changes.selectedUserData.currentValue) {
      //     this._selectedUserId = changes.selectedUserData.currentValue && changes.selectedUserData.currentValue.user && changes.selectedUserData.currentValue.user.user_id ? changes.selectedUserData.currentValue.user.user_id : '';
      this._selectedUserId = changes.selectedUserData.currentValue && changes.selectedUserData.currentValue.employee_fk_user_id ? changes.selectedUserData.currentValue.employee_fk_user_id : '';
      this._selectedUserData = changes.selectedUserData.currentValue ? changes.selectedUserData.currentValue : {};
      const userId = LocalStorageUtil.getUserId();
      this.isSameUser = userId === this._selectedUserId;
      // this.profile = userId === this._selectedUserId ? LocalStorageUtil.getUserRole() : 'Employee';
      this.dispatchGetShiftInfo();
    }
  }

  getUserRole() {
    this.masterBusinessStore.selectEmployeeRoleList().subscribe(res => {
      if (res && this._selectedUserData && this._selectedUserData.employee_fk_access_level_id) {
        const index = res.findIndex(data => data.business_role_id === this._selectedUserData.employee_fk_access_level_id);
        this.profile = LocalStorageUtil.getUserId() === this._selectedUserId ? LocalStorageUtil.getUserBusinessRole() : index !== -1 && res[index].business_role_name;
      }
    });
  }

  isLate() {
    if (this.shiftInfo && this.shiftInfo.location && this.shiftInfo.location.location_fk_timezone_name) {
      const shiftStart = moment.tz(this.shiftInfo.shift_start_date, this.shiftInfo.location.location_fk_timezone_name);
      const now = DateUtil.getCurrentDateTimeWithLocationTimezone(this.shiftInfo.location.location_fk_timezone_name);

      return now.isAfter(shiftStart);
      // return DateUtil.getCurrentDateTime().isAfter(moment(this.shiftInfo.shift_start_date));
    } else {
      return false;
    }
  }

  setLoggedInUserProfile() {
    const loginUserId = LocalStorageUtil.getUserId();
    if (loginUserId != this._selectedUserId) {
      this.isLoggedInUserProfile = false;
    } else {
      this.isLoggedInUserProfile = true;
    }
  }

  startShiftHandler() {
    if (this.loading()) {
      return;
    }
    //shift Restication for  location level
    // if (this.shiftInfo && this.shiftInfo.location.location_is_enable_start_shift_restriction && navigator.geolocation) {
    //   const position = await this.getCurrentPosition();
    //   const distance = CommonUtil.distance(position['coords'].latitude, position['coords'].longitude, +this.shiftInfo.location.location_latitude, +this.shiftInfo.location.location_longitude, 'K');
    //   const distanceThreshold = this.shiftInfo.location.location_fraud_distance_type === 'KILOMETER' ? this.shiftInfo.location.location_fraud_distance : this.shiftInfo.location.location_fraud_distance * 1000;
    //   if (distance > distanceThreshold) {
    //     this.toastr.error(ALERT_MESSAGES.SHIFT_RESTRICATION, '', { closeButton: true, timeOut: 3000 });
    //     return;
    //   }
    // }
    // check mandatory  form for buisness level (if User start shift) 
    this.setLoggedInUserProfile();
    if (this.isLoggedInUserProfile) {
      this.checkPendingFormList()
    }
    else {
      this.startShiftHandlerV2()
    }
  }
  startShiftHandlerV2() {
    this.setLocation();
    if (this.showLocationError) {
      return;
    }
    if (this.shiftInfo) {
      const shiftId = this.shiftInfo.shift_id;

      this.withCurrentLocation(location => this.dispatchGetStartForm({
        shift_id: shiftId,
        is_schedule: true,
        ...location,
      }));
    } else {
      new AmplitudeService().logEvent(AMPLITUDE_EVENT.ME_DASHBOARD_START_UNSCHEDULE, null);
      const compRef = this.openPopUp(StartUnscheduledShiftComponent, { findByUserId: this._selectedUserId ? this._selectedUserId : this.loggedInUserId }, { centered: true, size: 'lg', backdrop: 'static' });
      compRef.result.then(res => {
        if (res !== 'Close' && res && res.client_id && res.area_id && res.location_id) {
          const payload = {
            ...res,
            is_schedule: false,
          };
          this.shiftInfo = payload;
          this.shiftTimeSheetDetails = payload;
          this.unscheduledShiftData = payload;
          this.withCurrentLocation(location => this.dispatchGetStartForm({
            is_schedule: false,
            client_id: res.client_id,
            location_id: res.location_id,
            area_id: res.area_id,
            ...location,
          }));
        } else {
          this.refreshView();
        }
      }, () => {
        this.refreshView();
      });
    }
  }

  //  async getCurrentPosition() {
  //   return new Promise((resolve, reject) => {
  //     navigator.geolocation.getCurrentPosition(resolve, reject);
  //   });
  // }


  async checkPendingFormList() {
    const user_id = LocalStorageUtil.getUserId();
    let res;
    this.loading.set(true);
    try {
      res = await firstValueFrom(this.shiftInfoMainService.getPendingFormList(user_id));
    } catch (error) {
      this.loading.set(false);
      return;
    }
    this.loading.set(false);
    if (res.data.data.pending_forms) {
      this.displayPendingFormList(res, user_id);
    } else {
      this.startShiftHandlerV2();
    }
  }


  displayPendingFormList(res, user_id) {
    const compRef = this.openPopUp(CheckPendingFormComponent, { data: res, user_id: user_id }, { centered: true, size: 'lg', backdrop: 'static' });
    compRef.result.then(res => {
      if (res == 'Submit')
        this.startShiftHandler();
    });
  }

  setLocation() {
    if (navigator.geolocation && navigator.geolocation.getCurrentPosition) {

      navigator.geolocation.getCurrentPosition((position) => {
        this.showLocationError = false;
        this.location.latitude = position.coords.latitude || 0;
        this.location.logitude = position.coords.longitude || 0;
      }, () => {
        this.showLocationError = true;
      }, { enableHighAccuracy: false, timeout: 20000, maximumAge: 100000 });

    }
  }

  setScheduleInfo(shiftDetail) {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.timeElapsed.set('');
    if (shiftDetail) {
      const shiftInfoAndCount = shiftDetail;
      this.shiftTimeSheetDetails = shiftInfoAndCount;
      this.counts.shift_form_count = shiftInfoAndCount.shift_form_count;
      // this.counts.shift_loop_count = shiftInfoAndCount.shift_loop_count;
      this.counts.shift_patrol_count = shiftInfoAndCount.shift_patrol_count;
      this.counts.shift_reward_count = shiftInfoAndCount.shift_reward_count;
      this.counts.shift_task_group_count = shiftInfoAndCount.shift_task_group_count;
      this.hasAdvanceTask.set(!!shiftInfoAndCount.is_advance_task);
      this.timesheet = shiftInfoAndCount.timesheet;
      this.timesheetBreak = shiftInfoAndCount.timesheet_break || {};

      if (this.timesheet) {
        this.currentStatus = this.timesheet.timesheet_shift_status;
        this.unscheduledShiftData = this.timesheet.timesheet_is_unscheduled;
        this.setTimeElapsed(shiftInfoAndCount.location.location_fk_timezone_name);
        this.interval = setInterval(() => {
          this.setTimeElapsed(shiftInfoAndCount.location.location_fk_timezone_name);
        }, 60000);
      } else {
        this.currentStatus = TimesheetEnum.NONE;
      }
      if (shiftInfoAndCount.shift) {
        this.shiftInfo = this.convertDateOfEmployee(shiftInfoAndCount.shift, shiftInfoAndCount.location.location_fk_timezone_name);
        this.setBreakInfo();
      } else {
        this.shiftInfo = null;
      }
    }
    this.refreshView();
  }

  // Angular 21 hybrid CD does not re-check this view when shiftInfo/currentStatus
  // are mutated inside store subscribes or modal .result.then callbacks (worked
  // implicitly under zone-only Angular 8). Force a synchronous re-check so the
  // Start Shift button repaints immediately instead of on the next stray event.
  private refreshView() {
    try {
      this.cdr.detectChanges();
    } catch (e) { }
  }

  startBreakClickHandler() {
    if (this.loading()) {
      return;
    }
    new AmplitudeService().logEvent(AMPLITUDE_EVENT.ME_DASHBOARD_START_BREAK, null);
    this.setLocation();
    if (this.showLocationError) {
      return;
    }
    const paylod = {
      timesheet_id: this.timesheet ? this.timesheet.timesheet_id : 0,
      shift_id: this.shiftInfo ? this.shiftInfo.shift_id : 0,
      type: TimesheetType.TIMESHEET,
      break_type: TimeSheetBreakType.Both,
    };
    this.dispatchGetBreak(paylod);
  }

  // loopClickHandler() {
  //   if (!this.counts.shift_loop_count) {
  //     return;
  //   }
  //   const compRef = this.openPopUp(ShiftLoopListComponent, { shiftInfo: this.shiftTimeSheetDetails }, { centered: true, size: 'lg', backdrop: 'static' });

  // }
  patrolClickHandler() {
    if (this.loading()) {
      return;
    }
    if (!this.counts.shift_patrol_count) {
      return;
    }
    if (this.currentStatus === this.timeSheetEnumRef.NONE || !this.timesheet || !this.timesheet.timesheet_id) {
      this.toastr.infoShow(ALERT_MESSAGES.SHIFT_LOCATION_PATROL_RESTRICTION, '', { closeButton: true, timeOut: 3000 });
      return;
    }
    // if (!this.timesheet || !this.timesheet.timesheet_id) {
    //   return;
    // }
    this.loading.set(true);

    this.subscriptions.push(this.scheduleService.getShiftPatrolDetail({ timesheet_id: this.timesheet.timesheet_id }).subscribe(data => {
      if (data.success && data && data.data && data.data.data.patrol_detail) {
        const compRef = this.openPopUp(ShiftPatrolListComponent, { shiftInfo: this.shiftTimeSheetDetails , patrolDetail: data.data.data.patrol_detail, user_id: this.getUserId(), timesheet: this.timesheet }, { centered: true, size: 'lg', backdrop: 'static' });
        this.loading.set(false);
      }
      this.loading.set(false);
    }
      , (error) => {
        this.loading.set(false);
      }
    ));
  }

  resourceClickHandler(tab: ResourceTab = 'resources') {

    if (this.currentStatus === this.timeSheetEnumRef.NONE) {
      const message = tab === 'site-folder'
        ? ALERT_MESSAGES.SHIFT_LOCATION_SITE_FOLDER_RESTRICTION
        : ALERT_MESSAGES.SHIFT_LOCATION_RESOURCE_RESTRICTION;
      this.toastr.infoShow(message, '', { closeButton: true, timeOut: 3000 });
      return;
    }
    const compRef = this.openPopUp(LocationResourcesViewComponent, {
      locationId: this.shiftTimeSheetDetails.location.location_id,
      tab,
    }, { centered: true, size: 'xl', backdrop: 'static' });

  }

  taskActivityClickHandler() {
    if (this.currentStatus === this.timeSheetEnumRef.NONE) {
      return;
    }
    // On someone else's profile, show that person's tasks, view-only (tick and comment always act as the logged-in user).
    const userId = Number(this.getUserId()) || 0;
    const isOwn = !userId || userId === Number(this.loggedInUserId);
    // On a break the tasks can still be read, but nothing may be ticked or commented on until it ends.
    const onBreak = this.currentStatus === this.timeSheetEnumRef.ONBREAK;
    this.openPopUp(AdvanceTaskActivityComponent, {
      userId: isOwn ? 0 : userId,
      readOnly: !isOwn || onBreak,
      readOnlyReason: onBreak ? ALERT_MESSAGES.SHIFT_ON_BREAK_TASK_RESTRICTION : '',
    }, { centered: true, size: 'lg', backdrop: 'static' });
  }

  rewardClickHandler() {
    if (!this.counts.shift_reward_count) {
      return;
    }
    const compRef = this.openPopUp(ShiftRewardListComponent, { shiftInfo: this.shiftTimeSheetDetails }, { centered: true, size: 'lg', backdrop: 'static' });

  }

  formFillHandler() {
    if (this.loading()) {
      return;
    }
    if (!this.counts.shift_form_count) {
      return;
    }
    this.dispatchGetShiftForm({
      shift_id: this.shiftInfo ? this.shiftInfo.shift_id : 0,
      timesheet_id: this.timesheet ? this.timesheet.timesheet_id : 0,
      type: this.timesheet && this.timesheet.timesheet_id ? TimesheetType.TIMESHEET : TimesheetType.SHIFT,
    });
  }

  setTimeElapsed(timezone) {
    if (this.timesheet && this.timesheet.timesheet_actual_start_date) {
      // parse start date in its timezone
      const start = moment.tz(this.timesheet.timesheet_actual_start_date, 'YYYY-MM-DDTHH:mm:ss', timezone);

      // current time in same timezone
      const now = DateUtil.getCurrentDateTimeWithLocationTimezone(timezone);

      const seconds = Math.abs(start.diff(now, 'seconds'));

      // const seconds = Math.abs(moment(this.timesheet.timesheet_actual_start_date, 'YYYY-MM-DDTHH:mm:ss').diff(moment(), 'seconds', false));
      const hours = Math.floor(seconds / 3600).toString().padStart(2, '0');
      const minutes = Math.floor(seconds / 60).toString().padStart(2, '0');

      this.timeElapsed.set(`${hours} Hrs:  ${(+minutes) - ((+hours) * 60)} Mins `);
    }
  }

  convertDateOfEmployee(newEmployee, timezone) {
    newEmployee.shiftStartDate = newEmployee.shift_start_date;
    newEmployee.shiftEndDate = newEmployee.shift_end_date;
    newEmployee.shift_start_date = DateUtil.convertUtcToDateWithLocationTimezone(newEmployee.shift_start_date, timezone);
    newEmployee.shift_end_date = DateUtil.convertUtcToDateWithLocationTimezone(newEmployee.shift_end_date, timezone);
    const fromDateTime = DateUtil.splitDateTime(newEmployee.shift_start_date);
    const toDateTime = DateUtil.splitDateTime(newEmployee.shift_end_date);
    newEmployee.startTime = DateUtil.getTimeToSeconds(fromDateTime.time);
    newEmployee.endTime = DateUtil.getTimeToSeconds(toDateTime.time);
    newEmployee.startDate = fromDateTime.date;
    newEmployee.endDate = toDateTime.date;

    return newEmployee;
  }

  setBreakInfo() {
    if (!this.shiftInfo.shift_break) {
      this.shiftInfo.shift_break = [];
    }
    this.shiftInfo.meal_break = this.shiftInfo.shift_break.filter(breakDetail => breakDetail.shift_break_type === BREAK_TYPE_ENUM.MealBreak);
    this.shiftInfo.rest_break = this.shiftInfo.shift_break.filter(breakDetail => breakDetail.shift_break_type === BREAK_TYPE_ENUM.RestBreak);
  }

  getTaskGroup(data) {
    this.loading.set(false);
    if (data && data.success) {
      const tasks = data.data.data.task_Group || [];
      const compRef = this.openPopUp(TaskGroupListComponent, { tasks, user_id: this.getUserId(), shiftTimesheetInfo: this.shiftTimeSheetDetails, isUncsheduled: this.unscheduledShiftData ? true : false, timesheet: this.timesheet, currentStatus: this.currentStatus }, { centered: true, size: 'lg', backdrop: 'static' });
      compRef.result.then(res => {
        if (res && res.reopen) {
          this.taskGroupClickHandler();
        }
      });
    }
  }

  getShiftForm(data) {
    this.loading.set(false);
    if (data && data.success) {
      const forms = data.data.data.form || [];
      const compRef = this.openPopUp(ShiftFormListComponent, { forms, user_id: this.getUserId(), shiftTimesheetInfo: this.shiftTimeSheetDetails, isUncsheduled: this.unscheduledShiftData ? true : false, timesheet: this.timesheet }, { centered: true, size: 'lg', backdrop: 'static' });
      compRef.result.then(res => {
        if (res && res.reopen) {
          this.formFillHandler();
          this.dispatchGetShiftInfo();
        }
      });
    }
  }

  taskGroupClickHandler() {
    if (this.loading()) {
      return;
    }
    if (!this.counts.shift_task_group_count) {
      return;
    }
    this.dispatchGetShiftTaskGroup({
      shift_id: this.shiftInfo ? this.shiftInfo.shift_id : 0,
      timesheet_id: this.timesheet ? this.timesheet.timesheet_id : 0,
      type: this.timesheet && this.timesheet.timesheet_id ? TimesheetType.TIMESHEET : TimesheetType.SHIFT,
    });
  }

  dispatchGetShiftTaskGroup(data) {
    this.loading.set(true);
    this.scheduleStoreService.dispatchScheduleCommon({
      module: SCHEDULE_METHOD_CONSTANT.GET_TASK_GROUP,
      method: API_METHOD_CONSTANTS.GET_ALL_WITH_PARAMETERS,
      callback: this.getTaskGroup.bind(this),
      data,
    });
  }

  dispatchGetShiftForm(data) {
    this.loading.set(true)  ;
    this.scheduleStoreService.dispatchScheduleCommon({
      module: SCHEDULE_METHOD_CONSTANT.GET_SHIFT_FORMS,
      method: API_METHOD_CONSTANTS.GET_ALL_WITH_PARAMETERS,
      callback: this.getShiftForm.bind(this),
      data,
    });
  }

  dispatchGetBreak(data) {
    this.loading.set(true);
    this.scheduleStoreService.dispatchScheduleCommon({
      module: SCHEDULE_METHOD_CONSTANT.SHIFT_BREAK,
      method: API_METHOD_CONSTANTS.GET_ALL_WITH_PARAMETERS,
      callback: this.setBreak.bind(this),
      data,
    });
  }

  setBreak(data) {
    this.loading.set(false);
    if (data.success) {
      const compRef = this.openPopUp(StartBreakComponent, { breaks: data.data.data.shift_breaks, shiftDetails: this.shiftTimeSheetDetails, isUnscheduled: this.unscheduledShiftData }, { centered: true, size: 'lg', backdrop: 'static' });
      compRef.result.then(res => {
        if (res && res !== 'Close') {
          const payload = this.makeBreakPayload(res);
          this.dispatchStartBreak(payload);
        }
      });
    }
  }

  dispatchStartBreak(data) {
    this.loading.set(true);
    this.timesheetService.dispatchTimesheetCommon({
      module: TIMESHEET_METHOD_CONSTANT.START_BREAK,
      method: API_METHOD_CONSTANTS.INSERT,
      data,
      callback: this.updateSuccess.bind(this),
    });
  }

  makeScanClickHandler() {
    new AmplitudeService().logEvent(AMPLITUDE_EVENT.ME_DASHBOARD_MAKE_SCAN, null);
    if (this.shiftTimeSheetDetails && this.shiftTimeSheetDetails.area && this.shiftTimeSheetDetails.area.area_type_manual_enable) {
      const compRef = this.openPopUp(ScanAreaComponent, { shiftInfo: this.shiftTimeSheetDetails, user_id: this.getUserId() }, { centered: true, size: 'lg', backdrop: 'static' });
    } else {
      this.toastr.errorShow(ALERT_MESSAGES.MANUAL_SCAN_ERROR, '', { closeButton: true, timeOut: 3000 });
    }
  }

  makeLoopScanHandler() {
    new AmplitudeService().logEvent(AMPLITUDE_EVENT.ME_DASHBOARD_MAKE_LOOP_SCAN, null);
    const compRef = this.openPopUp(MakeLoopScanComponent, { shiftInfo: this.shiftTimeSheetDetails, user_id: this.getUserId() }, { centered: true, size: 'lg', backdrop: 'static' });
    compRef.result.then(res => res.reload ? this.dispatchGetShiftInfo() : null);
  }

  endBreakClickHandler() {
    this.setLocation();
    if (this.showLocationError) {
      return;
    }
    new AmplitudeService().logEvent(AMPLITUDE_EVENT.ME_DASHBOARD_END_BREAK, null);
    const compRef = this.openPopUp(EndBreakComponent, { shiftDetails: this.shiftTimeSheetDetails, breakDetail: this.timesheetBreak }, { centered: true, size: 'lg', backdrop: 'static' });
    compRef.result.then(res => {
      if (res === true) {
        this.dispatchEndBreak(this.makeEndBreakPayload());
      }
    });
  }

  dispatchEndBreak(data) {
    this.loading.set(true);
    this.timesheetService.dispatchTimesheetCommon({
      module: TIMESHEET_METHOD_CONSTANT.END_BREAK,
      method: API_METHOD_CONSTANTS.INSERT,
      data,
      callback: this.updateSuccess.bind(this),
    });
  }

  makeEndBreakPayload() {
    this.setLocation();

    return {
      shift_break_id: this.timesheetBreak.timesheet_log_sub_type_id,
      timesheet_id: this.timesheet.timesheet_id,
      timezone_id: 0,
      user_id: this.getUserId(),
      is_unscheduled: this.unscheduledShiftData ? true : false,
      timesheet_log: {
        timesheet_log_name: this.timesheetBreak.timesheet_log_name,
        timesheet_log_config: {},
        timesheet_log_is_paid: this.timesheetBreak.timesheet_log_is_paid,
      },
      timesheet_transaction: {
        timesheet_transaction_config: {},
        timesheet_transaction_device_config: CommonUtil.getShiftMetaData(),
        timesheet_transaction_device: 'Web',
        timesheet_transaction_app_version: this.getChromeVersion().toString(),
        timesheet_transaction_scan_type: '',
        timesheet_transaction_scan_image_url: '',
        timesheet_transaction_notes: '',
        timesheet_transaction_latitude: this.location.latitude.toString(),
        timesheet_transaction_longitude: this.location.logitude.toString(),
        timesheet_transaction_accuracy: 0.5,
      },
    };
  }

  startLoopClickHandler() {
    new AmplitudeService().logEvent(AMPLITUDE_EVENT.ME_DASHBOARD_START_LOOP, null);
    const compRef = this.openPopUp(StartLoopComponent, { shiftInfo: this.shiftTimeSheetDetails, user_id: this.getUserId() }, { centered: true, size: 'lg', backdrop: 'static' });
    compRef.result.then((res) => {
      if (res && res.reload) {
        this.dispatchGetShiftInfo();
      }
    });
  }

  shouldEndShift() {
    new AmplitudeService().logEvent(AMPLITUDE_EVENT.ME_DASHBOARD_END_SHIFT, null);
    const minLength = LocalStorageUtil.getBusinessMinShiftLength();
    const minutes = Math.abs(moment(this.timesheet.timesheet_actual_start_date, 'YYYY-MM-DDTHH:mm:ss').diff(moment(), 'minutes', false));
    if (minutes < minLength) {
      END_SHIFT_MODAL_CONSTANTS.message = END_SHIFT_MODAL_CONSTANTS.message.replace('business_setting_time', minLength);
      const modalRef = this.openPopUp(NotificationComponent, { options: END_SHIFT_MODAL_CONSTANTS });
      modalRef.result.then((res) => {
        if (res.STATUS === ModalButtonType.DELETE) {
          this.dispatchGetPendingTask({ timesheet_id: this.timesheet.timesheet_id });
        }
      });
    } else {
      this.dispatchGetPendingTask({ timesheet_id: this.timesheet.timesheet_id });
    }

  }

  endLoopClickHandler() {
    new AmplitudeService().logEvent(AMPLITUDE_EVENT.ME_DASHBOARD_END_LOOP, null);
    const compRef = this.openPopUp(EndLoopComponent, { shiftDetails: this.shiftTimeSheetDetails, user_id: this.getUserId() }, { centered: true, size: 'md', backdrop: 'static' });
    compRef.result.then(res => {
      if (res && res.reload) {
        this.dispatchGetShiftInfo();
      }
    });
  }

  setStartForm(data) {
    this.loading.set(false);
    if (this.currentStatus === TimesheetEnum.NONE && this.isGeofenceRestriction(data, START_FORM_GEOFENCE_RESPONSE_CODE)) {
      if (!this.timesheet && this.unscheduledShiftData) {
        this.shiftInfo = null;
        this.shiftTimeSheetDetails = null;
        this.unscheduledShiftData = null;
      }
      this.openGeofenceRestrictionPopup(data);
      this.refreshView();
      return;
    }
    let form = null;
    if (data.success) {
      form = data.data.data.form ? data.data.data.form : null;
    }
    const compRef = this.openPopUp(StartShiftComponent, { timesheet: this.timesheet, shiftDetails: this.shiftInfo, shiftAllInfo: this.shiftTimeSheetDetails, form, isUnScheduled: this.unscheduledShiftData, functionlity: this.currentStatus === TimesheetEnum.NONE ? ShfitFunction.Start : ShfitFunction.End }, { centered: true, size: 'lg', backdrop: 'static' });
    compRef.result.then(res => {
      if (res !== 'Close' && this.currentStatus === TimesheetEnum.NONE) {
        const payload = this.makeStartShiftpayload(res.form, res.camera, res.location, res.comment);
        this.dispatchStartShift(payload);
      } else if (res !== 'Close' && this.currentStatus !== TimesheetEnum.NONE) {
        const payload = this.makeEndShiftPayload(res.form, res.camera, res.location, res.comment);
        this.dispatchEndShift(payload);
      } else if (res === 'Close' && !this.timesheet && this.unscheduledShiftData) {
        this.shiftInfo = null;
        this.shiftTimeSheetDetails = null;
        this.unscheduledShiftData = null;
        this.refreshView();
      }
    }, () => {
      this.refreshView();
    });
  }

  makeStartShiftpayload(form, cameraUrl, location, comment) {

    const payload = {
      user_id: this.getUserId(),
      client_id: this.unscheduledShiftData ? this.unscheduledShiftData.client_id : this.shiftInfo.shift_fk_client_id,
      location_id: this.unscheduledShiftData ? this.unscheduledShiftData.location_id : this.shiftInfo.shift_fk_location_id,
      area_id: this.unscheduledShiftData ? this.unscheduledShiftData.area_id : this.shiftInfo.shift_fk_area_id,
      timezone_id: 2,
      is_unscheduled: this.unscheduledShiftData ? true : false,
      timesheet: {
        timesheet_fk_shift_id: this.unscheduledShiftData ? 0 : this.shiftInfo.shift_id,
        timesheet_config: {},
        timesheet_notes: '',
        timesheet_shift_start_comment: comment ? comment : '',
      },
      timesheet_log: {
        timesheet_log_name: '',
        timesheet_log_config: {},
        timesheet_log_is_paid: true,
      },
      timesheet_transaction: {
        timesheet_transaction_config: {},
        timesheet_transaction_device_config: CommonUtil.getShiftMetaData(),
        timesheet_transaction_device: 'Web',
        timesheet_transaction_app_version: this.getChromeVersion().toString(),
        timesheet_transaction_scan_type: 'image',
        timesheet_transaction_scan_image_url: cameraUrl,
        timesheet_transaction_notes: comment ? comment : '',
        timesheet_transaction_latitude: location.latitude ? location.latitude.toString() : '',
        timesheet_transaction_longitude: location.longitude ? location.longitude.toString() : '',
        timesheet_transaction_accuracy: 0.5,
      },
      timesheet_form: {
        timesheet_form_fk_form_id: form ? form.form_id : 0,
        timesheet_form_fk_form_name: form ? form.form_description : '',
        timesheet_form_details: form ? form : null,
        timesheet_form_config: {},
      },
      timesheet_forms: [
      ],
    };

    return payload;
  }

  makeEndShiftPayload(form, cameraUrl, location, comment) {
    return {
      timesheet_id: this.timesheet.timesheet_id,
      timezone_id: 1,
      user_id: this.getUserId(),
      timesheet_form_pending_reason: this.reasons ? this.reasons.timesheet_form_pending_reason : null,
      timesheet_task_pending_reason: this.reasons ? this.reasons.timesheet_task_pending_reason : null,
      // timesheet_loop_pending_reason: this.reasons ? this.reasons.timesheet_loop_pending_reason : null,
      timesheet_patrol_pending_reason: this.reasons ? this.reasons.timesheet_patrol_pending_reason : null,
      timesheet_shift_end_comment: comment ? comment : '',
      timesheet_transaction: {
        timesheet_transaction_config: {},
        timesheet_transaction_device_config: CommonUtil.getShiftMetaData(),
        timesheet_transaction_device: 'Web',
        timesheet_transaction_app_version: this.getChromeVersion().toString(),
        timesheet_transaction_scan_type: 'image',
        timesheet_transaction_scan_image_url: cameraUrl,
        timesheet_transaction_notes: comment ? comment : '',
        timesheet_transaction_latitude: location.latitude ? location.latitude.toString() : '',
        timesheet_transaction_longitude: location.longitude ? location.longitude.toString() : '',
        timesheet_transaction_accuracy: 0.5,
      },
      timesheet_form: {
        timesheet_form_fk_form_id: form ? form.form_id : 0,
        timesheet_form_fk_form_name: form ? form.form_description : '',
        timesheet_form_details: form ? form : null,
        timesheet_form_config: {},
      },
    };
  }


  pendingTask(data) {
    this.loading.set(false);
    if (data.success) {
      const timesheetEnd = data.data.data.Timesheet;
      if ((timesheetEnd.is_form_pending && this.ngxPermssionService.getPermission(PERMISSIONV2.FORM_MANAGEMENT)) || (timesheetEnd.is_patrol_pending && this.ngxPermssionService.getPermission(PERMISSIONV2.LOOP_PATROL)) || (timesheetEnd.is_task_pending && this.ngxPermssionService.getPermission(PERMISSIONV2.LOCATION_AREA_TASK))) {
        const compRef = this.openPopUp(ShouldEndShiftComponent, { timesheetPendingTask: timesheetEnd, shiftTimesheetInfo: this.shiftTimeSheetDetails, isUncsheduled: this.unscheduledShiftData ? true : false, timesheet: this.timesheet }, { centered: true, size: 'lg', backdrop: 'static' });
        compRef.result.then(res => {
          if (res && res.endShift) {
            this.endShiftHandler();
            this.reasons = res.reasons;
          } else if (res && res.reload) {
            this.shouldEndShift();
          }
        });
      } else {
        this.endShiftHandler();
      }
      // console.log(data);
    }
  }

  endShiftHandler() {
    this.setLocation();
    if (this.showLocationError) {
      return;
    }
    const payload = {
      shift_id: this.shiftInfo ? this.shiftInfo.shift_id : 0,
      is_schedule: this.unscheduledShiftData ? false : true,
      area_id: this.shiftTimeSheetDetails.area.area_id,
      client_id: this.shiftTimeSheetDetails.client.client_id,
      location_id: this.shiftTimeSheetDetails.location ? this.shiftTimeSheetDetails.location.location_id : 0,
    };
    this.dispatchGetEndForm(payload);
  }

  dispatchGetEndForm(data) {
    this.loading.set(true);
    this.scheduleStoreService.dispatchScheduleCommon({
      module: SCHEDULE_METHOD_CONSTANT.END_FORM,
      method: API_METHOD_CONSTANTS.GET_ALL_WITH_PARAMETERS,
      callback: this.setStartForm.bind(this),
      data,
    });
  }

  dispatchGetPendingTask(data) {
    this.loading.set(true);
    this.timesheetService.dispatchTimesheetCommon({
      module: TIMESHEET_METHOD_CONSTANT.PENDING_TASK,
      method: API_METHOD_CONSTANTS.GET_BY_ID,
      data,
      callback: this.pendingTask.bind(this),
    });
  }

  dispatchEndShift(data) {
    this.loading.set(true);
    this.unscheduledShiftData = null;
    this.reasons = null;
    this.timesheetService.dispatchTimesheetCommon({
      module: TIMESHEET_METHOD_CONSTANT.END_SHIFT,
      method: API_METHOD_CONSTANTS.INSERT,
      callback: this.updateSuccess.bind(this),
      data,
    });
  }

  dispatchStartShift(data) {
    this.loading.set(true);
    this.timesheetService.dispatchTimesheetCommon({
      module: TIMESHEET_METHOD_CONSTANT.START_SHIFT,
      method: API_METHOD_CONSTANTS.INSERT,
      data,
      callback: this.startShiftSuccess.bind(this),
    });
  }

  /**
   * Callback of start shift
   */
  startShiftSuccess(data) {
    if (this.isGeofenceRestriction(data)) {
      this.openGeofenceRestrictionPopup(data);
      return;
    }

    this.updateSuccess(data);
  }

  makeBreakPayload(breakDetail) {

    return {
      shift_break_id: breakDetail.break.shift_break_id,
      timesheet_id: this.timesheet.timesheet_id,
      timezone_id: 1,
      user_id: this.getUserId(),
      is_unscheduled: this.unscheduledShiftData ? true : false,
      timesheet_log: {
        timesheet_log_name: breakDetail.break.shift_break_name,
        timesheet_log_config: {},
        timesheet_log_is_paid: breakDetail.break.shift_break_type === BREAK_TYPE_ENUM.RestBreak,
      },
      timesheet_transaction: {
        timesheet_transaction_config: {},
        timesheet_transaction_device_config: CommonUtil.getShiftMetaData(),
        timesheet_transaction_device: 'Web',
        timesheet_transaction_app_version: this.getChromeVersion().toString(),
        timesheet_transaction_scan_type: '',
        timesheet_transaction_scan_image_url: '',
        timesheet_transaction_notes: '',
        timesheet_transaction_latitude: this.location && this.location.latitude ? this.location.latitude.toString() : '',
        timesheet_transaction_longitude: this.location && this.location.logitude ? this.location.logitude.toString() : '',
        timesheet_transaction_accuracy: 0,
      },
    };
  }

  /**
   * To run the next step once the device location is known
   */
  withCurrentLocation(next: (location: { latitude: string; longitude: string }) => void) {
    this.loading.set(true);
    CommonUtil.getCurrentLocation().then(location => this.ngZone.run(() => next(location)));
  }

  dispatchGetStartForm(data) {
    this.loading.set(true);
    this.scheduleStoreService.dispatchScheduleCommon({
      module: SCHEDULE_METHOD_CONSTANT.START_FORM,
      method: API_METHOD_CONSTANTS.GET_ALL_WITH_PARAMETERS,
      callback: this.setStartForm.bind(this),
      data,
    });
  }

  /**
   * Start shift refused because the employee is outside the geofence
   */
  isGeofenceRestriction(data, code = START_SHIFT_GEOFENCE_RESPONSE_CODE): boolean {
    const response = data && data.data;

    return !!(response && response.isError && response.code === code);
  }

  /**
   * To show the geofence refusal in an alert popup
   */
  openGeofenceRestrictionPopup(data) {
    this.loading.set(false);
    const areaLabel = MasterService.masterBusinessLabel.Area || 'area';
    const defaultMessage = START_SHIFT_GEOFENCE_MODAL_CONSTANTS.message.replace('{area}', areaLabel);
    const backendMessage = data.data.message ? data.data.message.replace('area', areaLabel) : null;

    // console.log(backendMessage , areaLabel, 'CHECK_BACKEND')
    this.openPopUp(NotificationComponent, {
      options: {
        ...START_SHIFT_GEOFENCE_MODAL_CONSTANTS,
        message: backendMessage || defaultMessage,
      },
    });
    this.dispatchGetShiftInfo();
  }
  updateSuccess(data) {
    this.loading.set(false);
    if (data && data.success && data.response && data.response.status >= 200 && data.response.status < 400) {
      this.dispatchGetShiftInfo();
    }
    else {
      this.toastr.errorShow((data && data.response && data.response.data && data.response.data.message) || (data && data.data && data.data.message), '', { closeButton: true, timeOut: 3000 });
      this.dispatchGetShiftInfo();
    }
  }


  success(data) {
    this.loading.set(false) ;
    this.setScheduleInfo(data.data.data.shifts);
    this.getUserRole();
  }

  handoverNotesClickHandler() {
    const employeeId = LocalStorageUtil.getEmployeeId();
    const modalRef = this.openPopUp(HandoverNotesComponent, { employee_id: employeeId, employee_user_id: this.getUserId(), shiftDetail: this.shiftTimeSheetDetails }, { centered: true, size: 'xl', keyboard: true, backdrop: 'static' });
  }


  dispatchGetShiftInfo() {
    this.loading.set(true);
    this.shiftInfoMainService.refresh$.next(true);
    this.scheduleStoreService.dispatchScheduleCommon({
      module: SCHEDULE_METHOD_CONSTANT.ME_SCHEDULED,
      method: API_METHOD_CONSTANTS.GET_BY_ID,
      data: { id: this._selectedUserId },
      callback: this.success.bind(this),
    });
  }

  shiftDetailsClickHandler() {
    new AmplitudeService().logEvent(AMPLITUDE_EVENT.ME_DASHBOARD_SHIFT_DETAIL, null);
    if (this.isSameUser) {
      this.activeScreen.shiftInfo = true;
      this.activeScreen.mainScreen = false;
      // emit from here for overlay switch
      this.showDetailsPanel.emit(true);
    } else {
      const detailsPopup = this.openPopUp(ShiftControlActualInfoComponent, { shiftAllInfo: this.shiftTimeSheetDetails, scheduleShiftDetails: this.shiftInfo }, { centered: true, size: 'lg', backdrop: 'static' });
      this.subscriptions.push(detailsPopup.componentInstance.eOpenModal.subscribe(res => {
        this.openModalHandler(res);
      }));
      this.subscriptions.push(detailsPopup.componentInstance.eStartShift.subscribe(res => {
        this.startShiftHandler();
      }));
    }
  }

  openModalHandler(modalType) {
    switch (modalType) {
      // case CountType.Loop:
      //   this.loopClickHandler();
      //   break;
      case CountType.Patrol:
        this.patrolClickHandler();
        break;
      case CountType.Form:
        this.formFillHandler();
        break;
      case CountType.Reward:
        this.rewardClickHandler();
        break;
      case CountType.Task:
        this.taskGroupClickHandler();
    }
  }

  showMainScreen() {
    this.activeScreen.shiftInfo = false;
    this.activeScreen.mainScreen = true;
  }

  getChromeVersion() {
    const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);

    return raw ? parseInt(raw[2], 10) : 0;
  }

  openPopUp(component: any, data?: { [key: string]: any }, options?: NgbModalOptions): NgbModalRef {
    const modalRef: NgbModalRef = this.modalService
      .open(component, options || { centered: true, backdrop: 'static' });
    if (data) {
      Object.keys(data).forEach(d => modalRef.componentInstance[d] = data[d]);
    }

    return modalRef;
  }

  getUserId() {
    return this._selectedUserId === this.loggedInUserId ? this.loggedInUserId : this._selectedUserId;
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }

    if (this.subscriptions) {
      this.subscriptions.forEach(sub => {
        sub.unsubscribe();
      });
    }

  }

}
